import { render, staticRenderFns } from "./bookShelf.vue?vue&type=template&id=e5d75fee&scoped=true&"
import script from "./bookShelf.vue?vue&type=script&lang=js&"
export * from "./bookShelf.vue?vue&type=script&lang=js&"
import style0 from "./bookShelf.vue?vue&type=style&index=0&id=e5d75fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d75fee",
  null
  
)

export default component.exports